export default {"src":"/_next/static/media/arrow-circle-right.ed80edf3.svg","height":37,"width":37};